export default __webpack_public_path__ + "static/media/bg-hero-proprietari-new.5ea0065c.png";